<template>
  <div class="container card">
    <div class="card__preview-wrp">
      <div v-if="sale.details.youtube_video_id">
        <iframe :src="`https://www.youtube.com/embed/${sale.details.youtube_video_id}?rel=0&start=0&end=60`"
                class="card__video"
        ></iframe>
      </div>
      <img v-else :src="imgUrl || getUrl" alt="campaign_preview">
    </div>

    <div class="card__content">
      <div class="card-header">
        <div class="card-header__status">
          <span v-if="sale.state === 'canceled'"><md-icon md-src="/static/img/cancel_icon.svg"/></span>
          <span v-if="sale.state === 'closed'"><md-icon md-src="/static/img/cancel_icon.svg"/></span>
          <span v-if="sale.state === 'open'"><md-icon md-src="/static/img/pending_icon.svg"/></span>
          <span>
            <span v-if="sale.state === 'open'">{{ sale.daysToEnd === 0 ? i18n.sale_ends_today() : i18n.sale_to_end({days: sale.daysToEnd}) }} </span>
            <span v-else>{{ i18n.com_campaign() }} {{ saleStatus }}</span>
          </span>
        </div>
        <div class="card-header__type">{{ saleType }}</div>
      </div>
      <div class="card-description">
        <div class="text_bold text_medium">{{ sale.name }}</div>
        <div class="card__text text_small">{{ sale.shortDescription }}</div>
        <!--<div class="card__location">-->
          <!--<span>Flag</span>-->
          <!--<span>Location</span>-->
        <!--</div>-->
      </div>
      <div class="card-progress">
        <div class="card-progress__stats text_small">
          <div v-if="profitability">
            <md-icon md-src="/static/img/grow_up_icon.svg"></md-icon>
            <div class="text_small">{{ profitability }}</div>
          </div>
          <div>
            <md-icon md-src="/static/img/man_icon.svg"></md-icon>
            <div class="text_small">{{ sale.investors }}</div>
          </div>
        </div>
        <div class="card-progress__bar">
          <div class="progress-line" :style="`width: ${progress}%`"></div>
        </div>
        <div class="card-progress__amounts">
          <div class="text_medium text_bold text_description">{{ assetIcon(sale.defaultQuoteAsset) }} {{ roundCurrency(sale.currentCap, sale.defaultQuoteAsset) }} </div>
          <div class="text_medium text_bold card__goal-amount">{{ assetIcon(sale.defaultQuoteAsset) }} {{ roundCurrency(sale.hardCap, sale.defaultQuoteAsset) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import config from '@conf'
  import _get from 'lodash/get'
  import { i18n } from '@js/i18n'
  import CurrencyRound from '@com/mixins/currency.round.mixin'
  import { CurrencyHelper } from '@js/helpers/currency.helper'

  export default {
    name: 'sale-card',
    mixins: [CurrencyRound],
    props: ['sale', 'hasEditRedirect', 'imgUrl'],
    data: _ => ({
      i18n,
      saleStatus: '',
      saleType: '',
      sale: ''
    }),
    created () {
      this.saleStatus = i18n[this.getTranslate('status')]()
      this.saleType = i18n[this.getTranslate('type')]()
      if (Date.parse(this.sale.startTime) > Date.parse(new Date())) this.saleStatus = i18n.com_upcoming_only()
    },
    computed: {
      progress () {
        const progress = Math.floor((this.sale.currentCap / this.sale.hardCap) * 100)
        return progress > 100 ? 100 : progress
      },
      getUrl () {
        const key = _get(this.sale, '_record.details.logo.key')
        if (!key) return ''
        return `${config.FILE_STORAGE}/${key}`
      },
      profitability () {
        if (this.sale.annualPercentage) {
          return this.sale.annualPercentage + '%'
        } else if (this.sale.profitability_from && this.sale.profitability_to) {
          return this.sale.profitability_from + ' - ' + this.sale.profitability_to + '%'
        } else {
          return ''
        }
      }
    },
    methods: {
      getTranslate (type) {
        if (type === 'status') {
          return ('lbl_status_' + this.sale.state)
        } else if (type === 'type') {
          return this.sale.details.internal_type ? ('sale_subtype_' + this.sale.details.internal_type) : ('sale_subtype_' + this.sale.details.type)
        }
      },
      assetIcon (asset) {
        return CurrencyHelper.getCurrencyIcon(asset)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~scss/variables';
  @import '~scss/mixins';

  .card {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    /*max-width: 100%;*/
    /*width: 100%;*/
    height: 100%;
    overflow: hidden;
    transition: all .5s;
    @include border(1px, 16px, $col-border);

    &:hover {
      transform: scale(1.01);
    }

    &__content {
      position: relative;
      display: flex;
      flex: 1 1 auto;
      flex-direction: column;
      height: auto;
      padding: 20px;
    }

    & .card-header {
      display: flex;
      justify-content: space-between;
      flex: 0 0 auto;
      font-size: 14px;
      line-height: 18px;

      &__status {
        display: flex;

        & i {
          width: 14px;
          height: 14px;
          min-width: unset;
          margin-right: 6px;
          font-family: unset;
          line-height: 14px;
          & svg {
            width: 100%;
            height: 100%;
            min-width: unset;
            font-size: 14px !important;
            line-height: 14px;
          }
        }
      }

      &__type {
        color: $col-md-primary;
      }
    }

    & .card-description {
      flex-grow: 2;
      max-height: 204px;
      margin: 20px 0;
      color: $col-text;
      overflow: hidden;
    }

    &__text {
      padding: 5px 0 10px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    & .card-progress {
      flex: 0 0 auto;
      &__amounts {
        display: flex;
        justify-content: space-between;
      }

      &__bar {
        width: 100%;
        height: 8px;
        margin: 10px 0;
        background: $col-md-accent;
        border-radius: 4px;

        & .progress-line {
          height: 100%;
          background: $col-md-primary;
          border-radius: 4px;
        }
      }

      &__stats {
        display: flex;
        justify-content: flex-start;
        text-align: center;

        & div {
          display: flex;
          align-items: center;

          &:first-child {
            margin-right: 28px;
          }

          & .md-icon {
            margin-right: 12px;
          }
        }
      }
    }

    &__goal-amount {
      color: $col-md-primary;
      text-align: right;
    }
  }


  .card__preview-wrp {
    position: relative;
    width: 100%;
    max-width: 100%;
    height: 180px;
    margin: 0 auto;

    & img {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
    & .card__video {
      width: 100%;
      border: 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/vue/app/sales/sale_card/Sales.SaleCard.vue